import { useAppI18N } from '@/app'
import { authWall } from '@/utils'
import { Organisation } from '@/features'
import { Button, View } from '@/components'

export const OrgReviewButtons = ({ onShare = null, isMyOrganisation = false }) => {
  if (!isMyOrganisation) return null
  return <Content onShare={onShare} />
}

function Content({ onShare }) {
  const { t } = useAppI18N()
  const { onPressStories, onPressOrganisation } = Organisation.Hooks.useAct()

  return (
    <View variants={['column', 'gap:2', 'fullWidth', 'paddingHorizontal:2']}>
      <View variants={['gap:1', 'fullWidth']}>
        <Button
          debugName='Add your views'
          onClick={authWall(() => onPressOrganisation())}
          variants={['outline', 'large', 'fullWidth']}
          icon='edit'
          text={t('organisations.addYourViews')}
        />
        <Button
          debugName='Success Stories'
          onClick={authWall(() => onPressStories())}
          variants={['outline', 'large', 'fullWidth']}
          icon='plus'
          text={t('organisations.addSuccessStory')}
        />
      </View>
      {onShare ? (
        <Button
          debugName='Invite to review'
          onPress={onShare}
          variants={['outline', 'large']}
          text={t('organisations.inviteColleagues')}
        />
      ) : null}
    </View>
  )
}
